module.exports = {
  back: 'خلف',
};
